import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import { Form } from 'react-bootstrap';

function BookingInTable({ data, handleRowChange, validated }) {
  const columns = useMemo(
    () => [
      {
        accessor: 'code',
        Header: 'Emplas Code',
        Cell: rowData => <span className="fw-semi-bold">{rowData.row.original.code}</span>
      },
      {
        accessor: 'supplierCode',
        Header: 'Supplier Code',
        Cell: rowData => <span className="fw-semi-bold">{rowData.row.original.supplierCode}</span>
      },
      {
        accessor: 'description',
        Header: 'Description',
        Cell: rowData => <span>{rowData.row.original.description}</span>
      },
      {
        accessor: 'balanceDue',
        Header: 'Balance Due',
        Cell: rowData => <span className="fw-bold text-primary">{rowData.row.original.balanceDue}</span>
      },
      {
        accessor: 'deliveryNoteQty',
        Header: 'Delivery Note Qty',
        Cell: rowData => (
          <Form.Control
            type="number"
            size="sm"
            className="text-center"
            value={rowData.row.original.deliveryNoteQty ?? ''}
            onChange={e => {
              handleRowChange(rowData.row.index, 'deliveryNoteQty', e.target.value);
            }}
          />
        )
      },
      {
        accessor: 'actualReceived',
        Header: 'Actual Received',
        Cell: rowData => (
          <Form.Control
            type="number"
            size="sm"
            className="text-center"
            value={rowData.row.original.actualReceived ?? ''}
            onChange={e => handleRowChange(rowData.row.index, 'actualReceived', e.target.value)}
          />
        )
      },
      {
        accessor: 'binBarcode',
        Header: () => <span className="required">Bin Barcode</span>,
        Cell: rowData => (
          <Form.Control
            size="sm"
            placeholder="Bin..."
            value={rowData.row.original.binBarcode || ''}
            isInvalid={
              validated &&
              rowData.row.original.actualReceived !== '' &&
              Number(rowData.row.original.actualReceived) !== 0 &&
              !rowData.row.original.binBarcode
            }
            onChange={e => handleRowChange(rowData.row.index, 'binBarcode', e.target.value)}
          />
        )
      }
    ],
    [handleRowChange, validated]
  );

  return (
    <div className="booking-in-table-wrapper sticky-zone shadow-sm border rounded bg-white overflow-hidden">
      <PartialTable
        data={data}
        columns={columns}
        total={data.length}
        paging={{ pageNum: 1, pageSize: 1000 }} 
        rowClassName="small"
        option={{ 
          isStickyHeader: true, 
          isStickyHeaderFull: true 
        }}
      />
    </div>
  );
}

BookingInTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleRowChange: PropTypes.func.isRequired,
  validated: PropTypes.bool
};

export default BookingInTable;
